export default [
  {
    header: 'Администрирование',
    resource: 'users',
    action: 'view',
  },
  {
    title: 'Пользователи',
    route: 'admin-users',
    icon: 'UsersIcon',
    resource: 'users',
    action: 'view',
  },
  {
    title: 'Роли',
    route: 'admin-roles',
    icon: 'ShieldIcon',
    resource: 'users',
    action: 'view',
  },
]
